import { FilterSetService } from './../../../services/filter-set.service';
import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BbTableService, BbTableSelectOption, TableRow } from '../../../services/bb-table.service';
import { SapiService } from '../../../services/sapi.service';
import { OverlayService } from '../../../services/overlay.service';
import { PublicationService } from '../../../services/publication.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { AbstractListComponent } from '../../shared/abstract-list.component';
import { Adunit } from '../adunit/adunit-list.component';

@Component({
	selector: 'ad-position-list',
	templateUrl: './ad-position-list.component.html',
	styleUrls: ['./ad-position-list.component.scss'],
	providers: [BbTableService, FilterSetService]
})

export class AdPositionListComponent extends AbstractListComponent implements OnInit {
	putRight = false;
	deleteRight = false;
	totalAmount = 0;

	private rootPermission = false;

	constructor(protected bbTableService: BbTableService,
		protected filterSetService: FilterSetService,
		protected sapiService: SapiService,
		protected router: Router,
		protected localStorageService: LocalStorageService,
		protected overlayService: OverlayService,
		protected translate: TranslateService,
		protected publicationService: PublicationService,
		protected authenticationService: AuthenticationService) {

		super(bbTableService, filterSetService);

		this.listConfiguration = {
			name: 'playout',
			basePath: '/adservices/position/playout',
			activePath: '/adservices/positions'
		};

		this.filterConfig = {
			search: true,
			filters: [],
			presets: [{
				label: this.translate.instant('ALL'),
				value: 'all',
				filterSet: [],
			},
			{
				label: this.translate.instant('WITH_AD_UNITS'),
				value: 'withadunits',
				filterSet: [{
					filters: [{
						type: 'playout',
						field: 'hasAdunits',
						operator: 'is',
						value: 'true'
					}]
				}],
			},
			{
				label: this.translate.instant('WITHOUT_AD_UNITS'),
				value: 'withoutadunits',
				filterSet: [{
					filters: [{
						type: 'playout',
						field: 'hasAdunits',
						operator: 'is',
						value: 'false'
					}]
				}]
			}]
		};

		this.authenticationService.hasPermission('put').subscribe(hasRight => this.putRight = hasRight);
		this.authenticationService.hasPermission('delete').subscribe(hasRight => this.deleteRight = hasRight);
		this.authenticationService.hasPermission('root').subscribe((hasRight: boolean) => this.rootPermission = hasRight);
		this.bbTableService.totalChangedObservable.subscribe(amount => this.totalAmount = amount);
		this.bbTableService.rowsRetrievedObservable.subscribe((rows: TableRow[]) => {
			if (rows) {
				rows.forEach((row: TableRow) => {
					if (row.data.adunits) {
						row.data.adunitsOverlay = row.data.adunits.filter((adunit: Adunit) => adunit.positionType === 'overlay');
					}
				});
			}
		});
	}

	currentFilterChanged(filter: string) {
		super.currentFilterChanged(filter);

		switch (filter) {
			case 'hasAdunits:true':
				this.currentFilter = 'withadunits';
				break;
			case 'hasAdunits:false':
				this.currentFilter = 'withoutadunits';
				break;
		}
	}

	goToUpgradedLink(playoutId: string, event: MouseEvent) {
		if (this.rootPermission && (event.ctrlKey || event.metaKey)) {
			event.preventDefault();
			this.router.navigate(['adservices/positionNG6/playout', playoutId]);
		}
	}

	ngOnInit() {
		this.bbTableService
			.setSelect(BbTableSelectOption.none)
			.setLimit(15)
			.sort('createddate', 'desc')
			.linkToUrl();

		super.ngOnInit();
	}
}
